import { ReactElement } from "react";
import Head from "next/head";

import { FormConfig } from "@evergiving/common/dist/es2015/form";

export function CommonHead({
  formConfig,
}: {
  formConfig: FormConfig;
}): ReactElement {
  return (
    <Head>
      <title>{formConfig.windowTitleText}</title>
    </Head>
  );
}
